import { useMemo } from "react";

import { MedChronService } from "../services/medChronService";
import { MedChronServiceV2 } from "../services/medChronServiceV2";
import { useAPI } from "./useAPI";

export const useMedChronServices = () => {
  const apiV1 = useAPI("v1");
  const apiV2 = useAPI("v2");
  const v1 = useMemo(() => new MedChronService(apiV1), [apiV1]);
  const v2 = useMemo(() => new MedChronServiceV2(apiV2), [apiV2]);
  return [v1, v2] as const;
};
